import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { SEO } from "@/components/site/SEO";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

export default function NewsletterThankYou() {
  return (
    <div className="min-h-screen bg-ivory" data-testid="thankyou-page-newsletter">
      <SEO title="Mastering Money Mondays — You're on the List | Legacy Life & Retirement" noindex />
      <Header />
      <main className="relative bg-ivory pt-[120px] md:pt-[150px] pb-24 md:pb-28 overflow-hidden">
        <div className="pointer-events-none absolute inset-0 grid-lines opacity-40" />
        <div className="container-lr relative max-w-3xl">
          <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-gold text-legacy"><Check size={26} /></span>
          <p className="eyebrow mt-6">Subscription received</p>
          <h1 className="mt-3 font-serif font-semibold tracking-display text-legacy text-3xl md:text-4xl leading-[1.08]">
            You&rsquo;re on the List
          </h1>
          <p className="mt-5 text-slate text-base md:text-lg leading-relaxed">
            Thank you for joining Mastering Money Mondays. Check your inbox and confirm your subscription so you do not miss the next weekly money lesson.
          </p>
          <p className="mt-4 text-slate text-base leading-relaxed">
            Each week, you&rsquo;ll receive practical insights designed to help you improve cash flow, build wealth, and create more financial control.
          </p>
          <div className="mt-9">
            <Link to="/resources" data-testid="newsletter-explore-resources" className="btn-base btn-gold text-[0.82rem] tracking-[0.1em] uppercase">
              Explore Free Resources<ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
